import actionsModule from './_actionsModule.js'
import data from './_data.js'
import insuranceModule from './_insuranceModule.js'
import earlyAccessModule from './_earlyAccessModule.js'
import prescriptionModule from './_prescriptionModule'

export default {
  /* MANDATORY div to anchor the component */
  selector: '#rxcApp',

  showUI: true,

  flowName: '',

  /* MANDATORY lens data, example format https://rxc.luxottica.com/dev/v3.0.0/standalone/mock/lenses/eyeLensesMockResponse.json */
  lensesData: {},

  /* MANDATORY frame and environment data */
  data,

  /* MANDATORY lens actions, needed to save, edit and add to cart */
  actionsModule,

  /* OPTIONAL insurance module, if not provided, insurance buttons won't be visible */
  insuranceModule,

  earlyAccessModule,

  prescriptionModule,

  showSummaryDetails: true,
  brand: 'rayban',
}
